<template>
  <el-header>
    <el-menu default-active="1" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item
        style="border-bottom:none;color:#909399;float:left;padding:0;margin-top:-5px"
        index="logo"
      >
        <img width="199px" class="logo" src="../../public/logo.png" />
      </el-menu-item>

      <el-submenu index="3" style="float:right">
        <template slot="title">设置</template>
        <el-menu-item v-if="isOpenId==0" @click="GetErWeiMaUrl" index="3-1">微信绑定</el-menu-item>
        <el-menu-item v-if="isOpenId==1" @click="UnBindWx" index="3-1">解除微信绑定</el-menu-item>
        <el-menu-item  index="3-2" @click="LogOut">退出</el-menu-item>
      </el-submenu>
      <el-submenu index="role" style="float:right">
        <template slot="title">{{currentUserRole.RoleName}}</template>
        <el-menu-item
          :index="item.Id"
          v-for="(item,index) in Roles"
          @click="changeRole(item)"
          :key="index"
        >{{item.RoleName}}</el-menu-item>
      </el-submenu>
      <el-menu-item style="border-bottom:none;color:#909399;float:right" index="4">{{date}}</el-menu-item>
      <!-- <el-menu-item
        @click="toDoneMessage"
        style="border-bottom:none;color:#909399;float:right"
        index="5"
      >
        待办事项
        <el-badge :value="this.NoReadModel.Count" class="mark" />
      </el-menu-item> -->
      <el-menu-item style="border-bottom:none;color:#909399;float:right" index="6">
        <div class="demo-basic--circle">
          <div class="block">
         {{UserDept}} <el-divider direction="vertical"></el-divider>{{UserName}}
          </div>
        </div>
      </el-menu-item>
            <el-menu-item style="float:right" index="7">
      <a href="/Wiki/index" >帮助</a><i class="el-icon-question"></i>
      </el-menu-item>
    </el-menu>

    <el-dialog title="识别二维码绑定微信" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <img style="text-align:center;width: 100%;" :src="erWeiMaUrl" />
      <div style="text-align:center;width: 100%;">如收到“锐之旗网络”公众号通知，说明绑定成功。即可关闭</div>
    </el-dialog>
  </el-header>
  
</template>
<script>
import {
  GetCurrentUserRoles,
  GetNoRead,
  BindWx,
  UnBindWx,
  GetErWeiMaUrl
} from "../until/ZeusApiSDK/Logic/HomeLogic";
import { Encrypt, Decrypt } from "../until/ZeusApiSDK/Logic/CryptoLogic";
import { GetCurrentTiket } from "../until/ZeusApiSDK/ZeusAPIClient";
export default {
  props: {
    _userinfo: {
      type: Object
    }
  },

  data() {
    return {
      Roles: {}, //角色
      Role: {},
      UserName: "", //姓名
      UserDept: "", //部门
      date: "",
      currentUser: this._userinfo, //当前用户信息
      isOpenId:0,
      NoReadModel: {}, //当前未读信息
      currentUserRole: {},
      erWeiMaUrl:'',//二维码图片地址
      dialogVisible:false,
      squareUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
    };
  },
  created() {
    this.GetRoles();

    //微信绑定
    this.bindWx();
    //获取待办事项未读信息

    //this.setWith();
  },
  mounted() {
    let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(() => {
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      _this.date = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
      //_this.date = this.getTime() // 修改数据date
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
  },
  methods: {
    //获取角色
    GetRoles: async function() {
      var currentUserRoles = window.sessionStorage.getItem("CurrentUserRoles");
      var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
      //如果app.vue传进来的user为空时
      if (!this.currentUser) {
        var tokenStr = window.localStorage.getItem("token");
        this.currentUser = GetCurrentTiket(tokenStr);
      }
      // this.GetNoRead();
      this.UserName = this.currentUser.TrueName;
      this.UserDept = this.currentUser.FrameName;
      //角色列表为空时
      if (!currentUserRoles || currentUserRoles == "undefined") {
        
        GetCurrentUserRoles(this.currentUser.UserId).then(cur => {
          window.sessionStorage.setItem(
            "CurrentUserRoles",
            Encrypt(JSON.stringify(cur))
          );

          this.currentUserRoles = cur;
          this.Roles = cur;
          this.currentUserRole = this.currentUserRoles[0];
          window.sessionStorage.setItem(
            "CurrentUserRole",
            Encrypt(JSON.stringify(this.currentUserRole))
          );
        });
      } else {
        //角色列表不为空
        this.Roles = JSON.parse(Decrypt(currentUserRoles));
        this.currentUserRoles = this.Roles;
        if (!currentUserRole || currentUserRole == "undefined") {
          this.currentUserRole = this.currentUserRoles[0];
          window.sessionStorage.setItem(
            "CurrentUserRole",
            Encrypt(JSON.stringify(this.currentUserRole))
          );
        } else {
          //当前角色不为空时
          this.currentUserRole = JSON.parse(Decrypt(currentUserRole));
        }
      }

      //当前角色为空时
    },
    handleSelect(key, keyPath) {
      if (keyPath[0] == "role") {
        this.currentUserRole = this.currentUserRoles.find(
          element => element.Id == key
        );
        if (
          this.currentUserRole != null &&
          this.currentUserRole != "" &&
          this.currentUserRole != "undefined"
        ) {
          window.sessionStorage.setItem(
            "CurrentUserRole",
            Encrypt(JSON.stringify(this.currentUserRole))
          );
          window.location.href = "/";
        }
      } else if (keyPath[0] == "logo") {
        this.$router.push("/");
      }
    },
    LogOut: function() {
      var token = window.localStorage.getItem("token");
      window.sessionStorage.clear();
      window.localStorage.clear();
      this.$http
        .post("/SSOLogin/unlogin", {
          token: token,
          url: this.$currentDomain
        })
        .then(() => {
          window.location.href = this.$loginUrl;
        })
        .catch(() => {
          window.location.href = this.$loginUrl;
        });
    },
    // //获取未读数据
    // GetNoRead: function() {
    //   //第一次加载页面进入
    //   this.intervalNoRead();
    //   this.myInterval = window.setInterval(() => {
    //     setTimeout(() => {
    //       //循环调用接口方法 1分钟调用一次
    //       this.intervalNoRead();
    //     }, 1);
    //   }, 60000);
    // },
    // //循环获取未读数据
    // intervalNoRead: function() {
    //   GetNoRead(this.currentUser.UserId).then(res => {
    //     if (res) {
    //       this.NoReadModel = res;
    //       if (this.NoReadModel != null && this.NoReadModel.Title != null&&this.NoReadModel.Title!=''&&this.NoReadModel.Title!='undefined') {
    //         //数据不为空时，弹出消息提示
    //         this.$notify({
    //           title: "您有一条新的消息",
    //           dangerouslyUseHTMLString: true,
    //           message:
    //             '<a target="_blank" style="text-decoration:none;color:#303030;" href="' +
    //             this.NoReadModel.Url +
    //             '">' +
    //             this.NoReadModel.Title +
    //             "</a>"
    //         });
    //       }
    //     } else {
    //       this.NoReadModel.Count = 0;
    //     }
    //   });
    // },
    //跳转到待办事项列表页
    // toDoneMessage: function() {
    //   this.$router.push("/Done/DoneMessage");
    // },
    //用户角色修改
    changeRole: function(roleModel) {
      if (roleModel != null && roleModel != "" && roleModel != "undefined") {
        this.currentUserRole = roleModel;
        window.sessionStorage.setItem(
          "CurrentUserRole",
          Encrypt(JSON.stringify(roleModel))
        );
        window.location.href = "/";
      }
    },
    //微信绑定
    bindWx:function(){
      BindWx(this.currentUser.UserId).then(res=>{
        this.isOpenId=res.IsOpenId;
      });
    },
    //获取二维码；链接
    GetErWeiMaUrl:function(){
      GetErWeiMaUrl(this.currentUser.UserId).then(res=>{
        if(res.IsOpenId==1){
          this.erWeiMaUrl=res.ErWeiMaUrl;
          this.dialogVisible=true;
        }
      })
    },
    //解除微信绑定
    UnBindWx:function(){
      UnBindWx(this.currentUser.UserId).then(res=>{
        if(res){
          this.$alert('您已解除“锐之旗网络”公众号绑定', '微信绑定解除', {
            confirmButtonText: '确定',
            callback: action => {
              window.location.href = "/";
            }
          });
        }
      });
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.dialogVisible=false;
          window.location.href = "/";
        })
        .catch(_ => {
        });
    }
  },
  watch: {
    _userinfo: {
      handler(n, o) {
        //n为新值,o为旧值;
        this.currentUser = n;
        this.GetRoles();
      },
      deep: true
    }
  }
};
</script>
<style lang="less" scoped>
.el-header {
  padding: 0 !important;
  /* height: 61px;
  border-bottom: solid 1px #e6e6e6; */
}
.show {
  display: block;
}
.hidden {
  display: none;
}
</style>